import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de680015ea98c7/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de680015ea98c7/node_modules/next/dist/client/link.js");
